import React, { useMemo } from "react";
import { getStorageValues } from "../../../shared/CommonFunctions";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";

export default function PendingEnquiryReport() {
  const columns = useMemo(
    () => [
      { name: "Enquiry #", selector: (r) => r.EnquiryNumber || "-" },
      { name: "Customer", selector: (r) => r.CustomerName || "-" },
      { name: "Mobile", selector: (r) => r.MobileNo || r.MobileNumber || "-" },
      { name: "Area", selector: (r) => r.Area || "-" },
      { name: "Enquire For", selector: (r) => r.EnquireFor || "-" },
      { name: "Status", selector: (r) => (Number(r.IsSold) === 1 ? "Sold" : "Pending") },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="pendingEnquiry"
      title="Pending Enquiry"
      columns={columns}
      fetchConfig={{
        url: "/enquiry/getall",
        paramsBuilder: (filters) => ({
          UserId: getStorageValues("userId"),
          IsForDropodown: "0",
          ...filters,
        }),
        transform: (data) => (Array.isArray(data) ? data.filter((x) => Number(x?.IsSold) === 0) : []),
      }}
      buildKpis={(rows) => [{ label: "Total Pending", value: rows?.length ?? 0 }]}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

